import { prepUrlForEnvironment } from '@sureapp/wl-toggle-common/dist/utils/url';
import produce from 'immer';

import { AUTO_DISCOUNTS } from '@@/auto/constants/autoDiscounts';
import { TConfig, TConfigInput } from '@@/auto/interfaces';
import carvanaLightLogo from '@@/common/assets/carvana/image/carvana_blue_logo.png';
import carvanaDefaultLogo from '@@/common/assets/carvana/image/carvana_white_logo.png';
import InverseToggleLogo from '@@/common/assets/toggle/image/TAFC-inverse.svg';
import LightToggleLogo from '@@/common/assets/toggle/image/TAFC-ongreen_1.svg';

const mfaSuccessHost = prepUrlForEnvironment({
  url: process.env.REACT_APP_MFA_SUCCESS_REDIRECT_HOST,
});

const config: DeepPartial<TConfigInput> = {
  coverageStartDateConfig: {
    infoCopy: null,
    labelCopy:
      'This date should be the same day as your appointment with Carvana',
    regionLabelCopy: {
      SC: 'This date should be one day prior to your appointment with Carvana.',
    },
  },
  discountsConfig: {
    partnerDiscounts: [
      {
        title: 'Carvana Customer Discount',
        description: AUTO_DISCOUNTS.affinity.description,
      },
    ],
  },
  featureFlags: {
    isAccountManagementEnabled: false,
    isAutoPurchaseFlowEnabled: true,
    isAutoQuoteLinkExchangeEnabled: true,
    isDirectToAutoQuoteEnabled: false,
    isLogoRedirectInAutoPurchaseFlowEnabled: true,
    isPrivacyAndTermsEnabled: false,
    isQuoteAssistForTenantEnabled: false,
    isRentersQuoteCreationEnabled: false,
    isSelfServiceEnabled: false,
  },
  footerConfig: (footerConfig: TConfig['footerConfig']) => ({
    ...footerConfig,
    hasNavItems: false,
    getSocialLinks: () => [],
  }),
  localforageDbName: 'carvana',
  logos: (logos: TConfig['logos']) => ({
    ...logos,
    default: carvanaDefaultLogo,
    light: carvanaLightLogo,
    title: 'Toggle + Carvana',
    toggleDefault: InverseToggleLogo,
    toggleLight: LightToggleLogo,
  }),
  navBarConfig: {
    getLinks: () => null,
  },
  notifyConfig: {
    discountCopy:
      'Congratulations on your new car and unlocking Carvana exclusive savings with Toggle Insurance!',
  },
  primaryVehicleDataSource: 'carvana',
  purchaseFlowConfig: (purchaseFlowConfig: TConfig['purchaseFlowConfig']) => ({
    ...purchaseFlowConfig,
    isCheckoutToggleCustomerDefault: false,
  }),
  quoteExpirationCondition: {
    maxElapsedTimeMinutes: 60,
    onConfirmDestination: 'https://www.carvana.com/',
    timestampKey: 'created_at',
  },
  redirectUrls: (redirectUrls: TConfig['redirectUrls']) => ({
    ...redirectUrls,
    indexRedirectUrl: 'https://www.carvana.com/',
    mfaSuccessRedirectUrl: `${mfaSuccessHost}my-account`,
    isPartnerRedirectUrlEnabled: true,
  }),
  signUpViewConfig: (signUpViewConfig: TConfig['signUpViewConfig']) =>
    produce(signUpViewConfig, (draft) => {
      Object.assign(draft.copy, {
        header:
          "Congrats on choosing the New Way to Buy a Car® from Carvana! Now get auto insurance and peace of mind in minutes. Our insurance is fully customizable so you don't have to pay for coverage you don't need.",
        informationalHeader: 'But first...',
        informationalSubHeader: 'Confirm the details below.',
      });
    }),
  tenantDisplayName: 'Carvana',
  tenantPhoneNumber: '',
  utmSourceTenantPhoneNumberMap: {},
  vehicleManagementCopyConfig: (
    vehicleManagementCopyConfig: TConfig['vehicleManagementCopyConfig']
  ) => ({
    ...vehicleManagementCopyConfig,
    subheader:
      "We've already included your new vehicle with Carvana. Feel free to add additional vehicles.",
  }),
};

export default config;
